import i18n from 'utils/i18n'
import type { CapturedWinesFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  SWITCHER,
  SCORE,
  INTERVAL,
  MULTISELECT_SWITCHER,
} from 'utils/consts'
import { getPersonCategory } from 'utils/company'
import { PersonCategories } from 'utils/consts/userRoles'
import {
  capturedWinesFiltersKey,
  capturedWinesFiltersName,
  capturedWinesFiltersTitle,
} from 'utils/consts/capturedWinesFilters'

// общая коллекция фильтров c их параметрами
export const getCapturedWinesFiltersCollection = () => {
  const category = getPersonCategory()
  const isBuyer = [
    PersonCategories.WHOLESALER,
    PersonCategories.RETAILER,
    PersonCategories.RESTAURANT,
  ].includes(category)

  return [
    {
      type: filterTypes[SWITCHER],
      title: i18n.t(
        isBuyer
          ? capturedWinesFiltersTitle.sellersOffersFilter
          : capturedWinesFiltersTitle.offerTypeFilter
      ),
      filterName: capturedWinesFiltersName.offerTypeFilter,
      apiFilterName: capturedWinesFiltersKey.offerTypeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.brandFilter),
      filterName: capturedWinesFiltersName.brandFilter,
      apiFilterName: capturedWinesFiltersKey.brandFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.wineTypeFilter),
      filterName: capturedWinesFiltersName.wineTypeFilter,
      apiFilterName: capturedWinesFiltersKey.wineTypeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.wineColourFilter),
      filterName: capturedWinesFiltersName.wineColourFilter,
      apiFilterName: capturedWinesFiltersKey.wineColourFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.sweetnessTypeFilter),
      filterName: capturedWinesFiltersName.sweetnessTypeFilter,
      apiFilterName: capturedWinesFiltersKey.sweetnessTypeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.vintageFilter),
      filterName: capturedWinesFiltersName.vintageFilter,
      apiFilterName: capturedWinesFiltersKey.vintageFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.nationalGITypeFilter),
      filterName: capturedWinesFiltersName.nationalGITypeFilter,
      apiFilterName: capturedWinesFiltersKey.nationalGITypeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.geoIndicationFilter),
      filterName: capturedWinesFiltersName.geoIndicationFilter,
      apiFilterName: capturedWinesFiltersKey.geoIndicationFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.specialClassificationFilter),
      filterName: capturedWinesFiltersName.specialClassificationFilter,
      apiFilterName: capturedWinesFiltersKey.specialClassificationFilter,
    },
    {
      type: filterTypes[MULTISELECT_SWITCHER],
      title: i18n.t(capturedWinesFiltersTitle.grapesFilter),
      filterName: capturedWinesFiltersName.grapesFilter,
      apiFilterName: capturedWinesFiltersKey.grapesFilter,
      switchType: filterTypes[SWITCHER],
      switchFilterName: capturedWinesFiltersName.monocepageFilter,
      switchTitle: i18n.t(capturedWinesFiltersTitle.monocepageFilter),
      switchApiFilterName: capturedWinesFiltersKey.monocepageFilter,
    },
    {
      type: filterTypes[INTERVAL],
      title: i18n.t(capturedWinesFiltersTitle.alcoholLevelFilter),
      filterName: capturedWinesFiltersName.alcoholLevelFilter,
      apiFilterName: capturedWinesFiltersKey.alcoholLevelFilter,
      defaultIntervalKey: 'alcoholLevels',
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.certificationFilter),
      filterName: capturedWinesFiltersName.certificationFilter,
      apiFilterName: capturedWinesFiltersKey.certificationFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.bottleSizeFilter),
      filterName: capturedWinesFiltersName.bottleSizeFilter,
      apiFilterName: capturedWinesFiltersKey.bottleSizeFilter,
    },
    {
      type: filterTypes[CHECKBOX_LIST],
      title: i18n.t(capturedWinesFiltersTitle.packageTypeFilter),
      filterName: capturedWinesFiltersName.packageTypeFilter,
      apiFilterName: capturedWinesFiltersKey.packageTypeFilter,
    },
    {
      type: filterTypes[SCORE],
      title: i18n.t(capturedWinesFiltersTitle.wwlRatingFilter),
      filterName: capturedWinesFiltersName.wwlRatingFilter,
      apiFilterName: capturedWinesFiltersKey.wwlRatingFilter,
    },
  ]
}

export const capturedWinesFiltersConfig: CapturedWinesFiltersConfig = {
  component: 'capturedWines',
  getFiltersCollection: getCapturedWinesFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
